import {SurveySettings} from 'common/models/survey';

export const namespace = 'survey';

export const initialState = {} as SurveySettings;
